import {InAppNotificationAction} from "../../types/notificationType";
import {useTranslation} from "react-i18next";
import {TextField, Typography} from "@mui/material";
import ServiceModuleReferenceField from "./notificationTypeReferenceFields/ServiceModuleReferenceField";
import ActionModuleReferenceField from "./notificationTypeReferenceFields/ActionModuleReferenceField";
import ShopModuleReferenceField from "./notificationTypeReferenceFields/ShopModuleReferenceField";


export default function ActionReferenceField({ action, onChange, isCompanyWideAssigned, groupIds, employeeUserIds }: {
    action: InAppNotificationAction;
    onChange: (action: InAppNotificationAction) => void;
    isCompanyWideAssigned: boolean;
    groupIds: number[];
    employeeUserIds: string[];
}) {
    const { t } = useTranslation();

    switch (action.type) {
        case "Profile":
        case "Wallet":
            return <Typography variant="body2" color="text.secondary">
                {t("genericInAppNotificationsPage.action.noReferenceNeeded")}
            </Typography>;

        case "ExternalUrl":
            return <TextField
                label={t("genericInAppNotificationsPage.action.reference.url")}
                value={action.reference ?? ""}
                onChange={(e) => onChange({ ...action, reference: e.target.value })}
                placeholder="https://..."
            />;

        case "ShopModule":
            return <ShopModuleReferenceField
                action={action}
                onChange={onChange}
                isCompanyWideAssigned={isCompanyWideAssigned}
                groupIds={groupIds}
                employeeUserIds={employeeUserIds}
            />;

        case "ActionModule":
            return <ActionModuleReferenceField
                action={action}
                onChange={onChange}
                isCompanyWideAssigned={isCompanyWideAssigned}
                groupIds={groupIds}
                employeeUserIds={employeeUserIds}
            />;

        case "ServiceModule":
            return <ServiceModuleReferenceField
                action={action}
                onChange={onChange}
                isCompanyWideAssigned={isCompanyWideAssigned}
                groupIds={groupIds}
                employeeUserIds={employeeUserIds}
            />;
    }
}